// ─── La ventana de una animación por código en la timeline ───────────────────
// ADR-2026-09-26-las-animaciones-se-recortan-como-un-video. Una animación por
// código tiene su duración REAL (la de la versión que escribió el generador) y el
// clip muestra una ventana de ella, igual que un clip de video muestra un tramo de
// su archivo: `sourceDuration` es lo que dura la animación, `mediaOffset` desde qué
// segundo se ve y `duration` cuánto. Así las manijas recortan (la izquierda saca el
// principio, la derecha corta el final) sin comprimir ni estirar la animación, y
// dividir deja cada mitad con su tramo. Antes el clip era como un texto: su
// `duration` le decía al código cuánto durar, y recortar re-temporizaba todo.

export interface ClipConVentana {
  type: string;
  duration: number;
  sourceDuration?: number;
  mediaOffset?: number;
  animationCodigo?: unknown;
}

/** Lo que dura la animación entera (con qué `duracionEnFrames` se dibuja). */
export function duracionNaturalDeAnimacion(clip: ClipConVentana): number {
  return clip.sourceDuration ?? clip.duration + (clip.mediaOffset ?? 0);
}

/**
 * Para los clips guardados antes de este cambio: toman como duración real la que
 * tenían en la timeline, así se siguen viendo igual (los que se estiraron, estirados).
 */
export function conVentanaDeAnimacion<T extends ClipConVentana>(clip: T): T {
  if (clip.type !== 'animation' || !clip.animationCodigo || clip.sourceDuration !== undefined) return clip;
  return { ...clip, sourceDuration: clip.duration + (clip.mediaOffset ?? 0) };
}

/** Una versión nueva (o volver a otra) muestra la animación entera: su duración, desde 0. */
export function ventanaDeVersion(duracionSeg: number): { duration: number; sourceDuration: number; mediaOffset: number } {
  return { duration: duracionSeg, sourceDuration: duracionSeg, mediaOffset: 0 };
}
